import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { ConsentFormResponse } from 'src/app/core/api/consent-form.util';

/** A declined consent form plus the picker key needed to resend it (null if it can't be resent). */
export interface DeclinedConsentRow {
  response: ConsentFormResponse;
  sendKey: string | null;
}

@Component({
  selector: 'csi-declined-consent-pill',
  templateUrl: './declined-consent-pill.component.html',
  styleUrls: ['./declined-consent-pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeclinedConsentPillComponent implements OnChanges {
  @Input() rows: DeclinedConsentRow[] = [];
  @Input() canResend = false;
  @Input() canManageWarnings = false;

  @Output() resendConsent = new EventEmitter<DeclinedConsentRow>();
  @Output() manageWarnings = new EventEmitter<void>();

  public pillLabelKey = '';
  public pillLabelParams: { count: number } = { count: 0 };

  ngOnChanges() {
    const count = (this.rows || []).length;
    this.pillLabelKey = count === 1 ? 'consentDeclinedPillOne' : 'consentDeclinedPillMany';
    this.pillLabelParams = { count };
  }

  public trackByQuestionnaireId(_index: number, row: DeclinedConsentRow): string {
    return row.response.questionnaire.id;
  }
}
